import { extendTailwindMerge } from 'tailwind-merge';
import { clsx, type ClassValue } from 'clsx';

// Mendly defines custom font-size utilities in globals.css (@theme): text-hero,
// text-h2, text-lead, etc. tailwind-merge doesn't know these are font-sizes, so
// by default it treats e.g. `text-lead` as conflicting with a `text-*` color
// and silently drops it. Register them as font-size classes so cn() keeps both
// the size and the color.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: ['hero', 'hero-sm', 'h2', 'h3', 'lead', 'eyebrow'] }],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
